var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"py-12 bg-gray-50"},[_c('BaseGridLayout',{attrs:{"size":"small"}},[_c('div',{staticClass:"col-span-full"},[_c('IconCarousel',{attrs:{"id":_vm.anchorName,"headline":_vm.headline,"sections":_vm.sections}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }